export default __webpack_public_path__ + "src/assets/images/calc_app_overlay-3704cd98.png";